export const DEFAULT_LAYOUT = 'default-layout'
export const EDITOR_LAYOUT = 'editor-layout'
